import React from "react";

import type { FooterLinkProps } from "../footer-link";

import { FooterLink } from "../footer-link";
import { WithTitle } from "../with-title";

type LinksWithTitleBlockProps = {
  className?: string;
  title: string;
  links: readonly FooterLinkProps[];
  withDivider?: boolean;
};

export const LinksWithTitleBlock: React.FC<LinksWithTitleBlockProps> = ({
  title,
  links
}) => {
  return (
    <WithTitle title={title}>
      <ul className="flex flex-col gap-100">
        {links.map((link_props, index) => (
          <li key={`${title.toLowerCase()}-link-${index}`}>
            <FooterLink {...link_props} />
          </li>
        ))}
      </ul>
    </WithTitle>
  );
};
